import { Component } from 'react'
import styled from 'glamorous'
import { compose, graphql } from 'react-apollo'

import { div, $ } from 'utils'
import { Icon, HeaderRow, Loader } from 'components'
import { VERIFY_FACE, DESCRIPTOR } from 'queries'
import { withConsumer } from 'store'

import VerificatedPerson from './VerificatedPerson'
import OriginalFace from './OriginalFace'


const Container = styled.div({
  width: '100%',
  height: '100%',
})

const HeaderContainer = styled.div({
  padding: '25px 30px 0 30px',
  borderBottom: '1px solid var(--borderColor)',
})

const ContentContainer = styled.div({
  height: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
})

const PanelContainer = styled.div({
  position: 'absolute',
  bottom: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'white',
  zIndex: 1060,
  transform: 'translateY(100%)',
  animation: 'var(--animationSlideUp)',
}, ({ shown }) => !shown && ({
  animation: 'var(--animationSlideDown)',
}), 'BottomPanel')

class VerificationResults extends Component {

  state = {
    shown: true
  }

  close = () => {
    this.setState({ shown: false })
    setTimeout(() => { this.props.closeBottomPanel() }, 500)
  }

  render() {
    const { data: { loading, verify, error }, descriptorData: { descriptor } } = this.props
    const { shown } = this.state
    if (loading) return $(Loader)

    return (
      $(PanelContainer, { shown },
        $(Container,
          $(HeaderContainer,
            $(HeaderRow, { label: 'Verification' },
              div({ onClick: this.close },
                $(Icon, { type: 'close', color: 'var(--lightGrey)' })
              )
            ),
          ),
          $(ContentContainer,
            $(OriginalFace, { descriptor }),
            $(VerificatedPerson, { loading, verify, error })
          )
        )
      )
    )
  }
}

export default
  compose(
    graphql(VERIFY_FACE, {
      options: props => ({
        fetchPolicy: 'cache-and-network',
        variables: {
          personId: props.personId,
          descriptorId: props.descriptorId,
        }
      })
    }),
    graphql(DESCRIPTOR, {
      name: 'descriptorData',
      options: props => ({
        fetchPolicy: 'cache-and-network',
        variables: {
          uuid: props.descriptorId
        }
      })
    }),
)(withConsumer(VerificationResults, '/faces'))



// WEBPACK FOOTER //
// ./src/components/panels/VerificationResults/index.js